import { createAction, props } from '@ngrx/store';
import { CareAppListActionFactory } from '../action-factory';

class StreamActions extends CareAppListActionFactory<void> {
  constructor() {
    super(`Stream`);
  }

  requestInitStream = createAction(`[${this.type}][Request] Init Stream`);
  responseSuccessInitStream = createAction(`[${this.type}][Response][Success] Init Stream`);
  responseFailInitStream = createAction(
    `[${this.type}][Response][Fail] Init Stream`,
    props<{ error: any }>(),
  );

  requestStreamToken = createAction(`[${this.type}][Request] access token`);
  responseSuccessStreamToken = createAction(
    `[${this.type}][Response][Success] access token`,
    props<{ token: string }>(),
  );
  responseFailStreamToken = createAction(
    `[${this.type}][Response][Fail] access token`,
    props<{ error: string }>(),
  );

  streamDisconnectedSuccess = createAction(`[${this.type}][Disconnect][Success]`);
  streamDisconnectedFail = createAction(
    `[${this.type}][Disconnect][Fail]`,
    props<{ error: any }>(),
  );

  requestMarkAllRead = createAction(`[${this.type}][Request] mark all read`);
  successMarkAllRead = createAction(`[${this.type}][Success] mark all read`);
  failMarkAllRead = createAction(`[${this.type}][Fail] mark all read`, props<{ error: any }>());
}

export const StreamAction = new StreamActions();
